import { useContext } from 'react'

import { SidebarManagerContext } from '../contexts/sidebar-manager'

export const useSidebarManager = () => useContext(SidebarManagerContext)

export default useSidebarManager
